import styled from '@emotion/styled';
import { EmotionIcon } from '@hotjar/webapp/features/Feedback/EmotionIcon';
import type { ReactionScore, ReactionStyle } from '../../domain/Surveys/Questions/SurveyQuestion';
import type { EmotionScore } from '../FeedbackIcon/FeedbackIconTypes';

const StyledEmotionIcon = styled(EmotionIcon)`
  display: flex;
  flex-flow: nowrap;
`;

interface ReactionIconProps {
  reactionStyle: ReactionStyle;
  score?: ReactionScore;
}

const renderReaction = ({ score, reactionStyle }: ReactionIconProps): JSX.Element | null => {
  if (typeof score === 'undefined') return null;

  // In order not to have the exact same code twice
  // we are just passing a score that it accepts (0-4)
  // When merging, the component can be modified to take 1-5 values
  const surveyScore = score - 1;
  return (
    <StyledEmotionIcon
      size={reactionStyle === 'star' ? 's' : 'l'}
      score={surveyScore as EmotionScore}
      ariaLabel={`Reaction score: ${score}`}
      emotionStyle={reactionStyle}
    />
  );
};

export const ScoreReactionIcon = ({
  reactionStyle,
  score,
}: ReactionIconProps): JSX.Element | null => {
  return renderReaction({ reactionStyle, score });
};
